export const SUPPORTED_IMG_TYPES = {
    POSTER: 'POSTER',
    THUMB: 'THUMB'
  };
  